import Container from "@saleor/components/Container";
import PageBackNavigation from "@saleor/components/PageBackNavigation";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useUser from "@saleor/hooks/useUser";
import { SmopStatusEnum, SmopUserTypeCode } from "@saleor/types/globalTypes";
import { canManageMalls } from "@saleor/utils/handlers/userHandler";
import React from "react";
import { useIntl } from "react-intl";
import { Navigate } from "react-router-dom";

import MallCreatePage, {
  MallCreatePageFormData
} from "../../components/MallCreatePage/MallCreatePage";
import { useMallCreateMutation } from "../../mutations";
import { MallCreate as MallCreateData } from "../../types/MallCreate";
import { mallListUrl } from "../../urls";
export const MallCreate: React.FC<{}> = () => {
  const intl = useIntl();
  const user = useUser();
  const navigate = useNavigator();
  const notify = useNotifier();

  const handleSuccess = (data: MallCreateData) => {
    if (data?.mallCreate?.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Mall created"
        })
      });
      navigate(mallListUrl());
    } else if (data.mallCreate.errors.some(e => e.code === "REQUIRED")) {
      notify({
        status: "error",
        text: intl.formatMessage({
          defaultMessage: "Some Fields have null value!"
        })
      });
    } else if (
      data.mallCreate.errors.some(
        e =>
          e.code === "INVALID" &&
          e.message === "Mall with this Slug and Deleted at already exists."
      )
    ) {
      notify({
        status: "error",
        text: intl.formatMessage({
          defaultMessage: "Mall name already exists"
        })
      });
    } else {
      notify({
        status: "error",
        text: intl.formatMessage({
          defaultMessage: "Invalid Form!"
        })
      });
    }
  };

  const [createMall, createMallResult] = useMallCreateMutation({
    onCompleted: handleSuccess
  });

  const onSubmit = (formData: MallCreatePageFormData) => {
    const mallCreateInput = {
      address: "",
      city: formData.city,
      code: formData.code,
      contactPerson: formData.contactPerson,
      description: "",
      email: formData.email,
      expressDeliveryAvailable: formData.expressDeliveryAvailable,
      expressLongDistanceAvailable: formData.expressLongDistanceAvailable,
      foodAndBevCutoffTime: formData.foodAndBevCutoffTime
        ? formData.foodAndBevCutoffTime
        : "19:00",
      genMerchCutoffTime: formData.genMerchCutoffTime
        ? formData.genMerchCutoffTime
        : "17:00",
      groceryCutoffTime: formData.groceryCutoffTime
        ? formData.groceryCutoffTime
        : "19:00",
      isInMallPickup: formData.isInMallPickup,
      isNationwideDelivery: formData.isNationwideDelivery,
      latitude: formData.latitude,
      longitude: formData.longitude,
      mallAdmin: "",
      mallClosing: formData.mallClosing,
      mallOpening: formData.mallOpening,
      mobileNo: formData.mobileNo,
      name: formData.name,
      nextDayAvailable: formData.nextDayAvailable,
      provinceCode: formData.provinceCode,
      provinceName: formData.provinceName,
      sameDayAvailable: formData.sameDayAvailable,
      sameDayGmCutoffTime: formData.sameDayGmCutoffTime
        ? formData.sameDayGmCutoffTime
        : "16:00",
      serviceArea: parseFloat(formData.serviceArea).toFixed(3),
      smMarketExternalCode: formData.smMarketExternalCode,
      smMarketExternalId: formData.smMarketExternalId,
      smMarketExternalName: formData.smMarketExternalName,
      status: formData.isActive ? SmopStatusEnum.ACT : SmopStatusEnum.INA,
      telephoneNo: formData.telephoneNo,
      totalLandArea: parseFloat(formData.totalLandArea).toFixed(3)
    };

    createMall({
      variables: {
        input: mallCreateInput
      }
    });
  };

  const breadcrumbDirectory = [
    {
      name: "Malls",
      url: "/malls"
    },
    {
      name: "Create Mall"
    }
  ];

  return (
    <>
      {user?.user?.userType?.code !== SmopUserTypeCode.MARKETING ? (
        <Container>
          <PageBreadcrumbNavigation items={breadcrumbDirectory} />
          <div
            style={{ display: "flex", flexDirection: "row", marginTop: "10px" }}
          >
            <PageBackNavigation onBack={() => navigate(mallListUrl())} />
            <PageHeader
              title={intl.formatMessage({
                defaultMessage: "Create Mall",
                description: "create details"
              })}
            ></PageHeader>
          </div>
          <MallCreatePage
            errors={createMallResult?.data?.mallCreate?.errors || []}
            disabled={createMallResult.loading}
            saveButtonBarState={createMallResult.status}
            onSubmit={onSubmit}
            onBack={() => navigate(mallListUrl())}
            hasManageMallPermission={canManageMalls()}
          />
        </Container>
      ) : (
        <Navigate to="/malls" replace />
      )}
    </>
  );
};
export default MallCreate;
